// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"c147d796","115":"583ba3d8","300":"9ca7da03","453":"3e5a488b"}[chunkId] + ".chunk.js";
};